module.exports = __webpack_public_path__ + "static/fx_2.6b626ea0.jpg";